import script from "./Pass.vue?vue&type=script&setup=true&lang=js"
export * from "./Pass.vue?vue&type=script&setup=true&lang=js"

import "./Pass.vue?vue&type=style&index=0&id=7ec8ccaf&scoped=true&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec8ccaf"]])

export default __exports__